import React from 'react';
import * as Styled from './styled';

const IconButton = ({ onClick, children }) => {
  return <Styled.IconWrapper onClick={onClick}>{children}</Styled.IconWrapper>;
};

export default IconButton;
